import CamerasPage from './components/CamerasPage';
import MobileParkingMetersPage from '../ParkingMeter/components/MobileParkingMetersPage';
import Empty from '../../components/base/Empty';
import MobileCamerasPage from './components/MobileCamerasPage';

const routes = [
  {
    path: '/cameras',
    name: 'menu.cameras',
    icon: 'videocam',
    customIcon: true,
    loginRequired: true,
    component: CamerasPage,
    weight: 1,
    permission: ['frontend_menu_camera'],
    children: [],
  },
  {
    path: '/cameras',
    name: 'menu.cameras',
    icon: 'videocam',
    customIcon: true,
    loginRequired: true,
    component: MobileCamerasPage,
    weight: 1,
    permission: ['frontend_menu_camera'],
    children: [],
    forMobile: true,
  },
];

export default routes;
